import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCandlestickChart = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M18 7.6H16.6667V5H15.3333V7.6H14V15.4H15.3333V18H16.6667V15.4H18V7.6ZM16.6667 14.1H15.3333V8.9H16.6667V14.1Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 6.66667H8.66667V4H7.33333V6.66667H6V13.3333H7.33333V16H8.66667V13.3333H10V6.66667ZM8.66667 12H7.33333V8H8.66667V12Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.5 2.75C3.5 2.33579 3.16421 2 2.75 2C2.33579 2 2 2.33579 2 2.75V21.25C2 21.6642 2.33579 22 2.75 22H21C21.4142 22 21.75 21.6642 21.75 21.25C21.75 20.8358 21.4142 20.5 21 20.5H3.5V2.75Z",
			fill: "var(--colors-grey-1)"
		})
	]
});
export default SvgCandlestickChart;
